import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

import RouteErrorBoundary from 'src/components/RouteErrorBoundary';

const AdminStandaloneLayout = () => (
  <Box sx={{ minHeight: '100vh', bgcolor: '#f5f3ee' }}>
    <RouteErrorBoundary>
      <Outlet />
    </RouteErrorBoundary>
  </Box>
);

export default AdminStandaloneLayout;
